import { PayloadMessage } from '../../types';

/**
 * Drop `time` from every message.
 *
 * Reminder, annual and join messages are anchored to an event (the appointment,
 * the contact date, the join) rather than to a wall-clock time, and the API
 * rejects the field for those types. `undefined` is equivalent to deleting the
 * key: JSON.stringify omits it.
 */
export const withoutMessageTime = (messages: PayloadMessage[]): PayloadMessage[] =>
  messages.map((m) => ({ ...m, time: undefined }));
